import { useEffect, useState } from 'react';

import { cmsApiFetchReaction } from 'modules/cms/api/cmsApiReactionEndpoints';
import { CmsApiReactionType } from 'modules/cms/api/types/CmsApiReactionType';

export function useCmsReactions(contentId: string) {
  const [reactionType, setReactionType] = useState<
    CmsApiReactionType | undefined
  >();

  useEffect(() => {
    cmsApiFetchReaction(contentId).then(({ ownReaction }) => {
      if (ownReaction) {
        setReactionType(ownReaction.reactionType);
      }
    });
  }, [contentId]);

  return { reactionType, setReactionType };
}
